import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs/operators';
import { UserService } from 'src/app/auth/service/user.service';
import { UserBreathWorkout } from 'src/app/models/user-breath-workout.model';
import { UserCardioWorkout } from 'src/app/models/user-cardio-workout.model';
import { ActivityTrackerService } from 'src/app/services/activity-tracker.service';
import { DateHelperService } from 'src/app/services/date-helper.service';
import { UserBreathWorkoutService } from 'src/app/services/user-breath-workout.service';
import { UserCardioService } from 'src/app/services/user-cardio.service';
import { UserDrinksService } from 'src/app/services/user-drinks.service';
import { UserEatWellService } from 'src/app/services/user-eat-well.service';
import { UserFeelsService } from 'src/app/services/user-feels.service';
import { UserSleepsService } from 'src/app/services/user-sleeps.service';
import { UserSmokingService } from 'src/app/services/user-smoking.service';
import { UserStepService } from 'src/app/services/user-step.service';
import { UserStrengthWorkoutService } from 'src/app/services/user-strength-workout.service';
import { UserTargetService } from 'src/app/services/user-target.service';
import { UserTaskStatusService } from 'src/app/services/user-task-status.service';
import { WeeklyReportService } from 'src/app/services/weekly-report.service';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements OnInit {
  weekNo = 0;
  page = 1;
  pageId = '';
  pages: any = [];
  isLoading = false;

  allSteps: any;
  todaySteps = 0;
  stepTarget: any;
  stepWeekData: any;
  stepPrevWeekData: any;
  allWeeksStepData: any = [];
  weekStepTotal = 0;
  stepDaysHit = 0;
  stepDaysHitLastWeek = 0;
  stepDaysHitFirstWeek = 0;

  daysToSurgery = 0;
  currentWeekNumber = 0;
  userData: any;

  allBreathWorkouts?: UserBreathWorkout[];
  breatheWeekData: any;
  breatheLast7Days: any;
  currentBreathLevel: any;
  breathLevelChange: any;
  allWeeksBreatheData: any = [];
  breatheSessions = 0;
  breatheSessionsLastWeek = 0;
  breatheSessionsFirstWeek = 0;

  breatheWeekWorkouts = 0;
  breatheFirstWeekWorkouts = 0;
  breatheLastWeekWorkouts = 0;

  firstWeekBreatheMax = 0;
  thisWeekBreatheMax = 0;
  lastWeekBreatheMax = 0;

  allCardioWorkouts?: UserCardioWorkout[];
  cardioWeekData: any;
  cardioMinsWeek = 0;
  cardioMinsWeekModerate = 0;
  cardioMinsWeekVigorous = 0;
  cardioProgress = 0;
  allWeeksCardioData: any = [];
  cardioMinsLastWeek = 0;
  cardioMinsLastWeekModerate = 0;
  cardioMinsLastWeekVigorous = 0;
  cardioMinsFirstWeek = 0;
  cardioPrevWeekData: any;
  cardioWeekProgressed: any = null;
  cardioWeekHit = false;

  allMoveWorkouts: any;
  moveWeekData: any;
  moveProgress = 0;
  moveWeekWorkouts = 0;
  moveLastWeekWorkouts = 0;
  moveFirstWeekWorkouts = 0;
  allWeeksMoveData: any = [];
  moveWeekProgressed: any = null;
  moveWeekHit = false;

  allEatWells: any;
  eatWellWeekData: any;
  eatWellTotals: any;
  eatWellTotalsFirstWeek: any;
  eatWellTotalsLastWeek: any;
  allWeeksEatWellData: any = [];
  eatWellStats: any;
  eatWellStatsLastWeek: any;
  eatWellStatsFirstWeek: any;
  eatWellDaysHit = 0;
  eatWellDaysHitLastWeek = 0;
  eatWellDaysHitFirstWeek = 0;

  allSmokings: any;
  smokingWeekData: any;
  smokingTotals: any;
  smokingLastWeekData: any;
  smokingTotalsLastWeek: any;
  smokingTotalsFirstWeek: any;
  smokingChanges: any;
  allWeeksSmokingData: any = [];

  allDrinks: any;
  drinkWeekData: any;
  drinkTotals: any;
  drinkLastWeekData: any;
  drinkTotalsLastWeek: any;
  drinkTotalsFirstWeek: any;
  drinkChanges: any;
  allWeeksDrinkData: any = [];

  allFeels: any;
  feelWeekData: any;
  feelTotal: any;
  feelLastWeekData: any;
  feelTotalLastWeek: any;
  feelTotalFirstWeek: any;
  feelChange: any;
  allWeeksFeelWellData: any = [];

  allSleeps: any;
  sleepWeekData: any;
  sleepTotal: any;
  sleepLastWeekData: any;
  sleepTotalLastWeek: any;
  sleepTotalFirstWeek: any;
  sleepChange: any;
  allWeeksSleepWellData: any = [];

  allTaskStatuses: any;

  public lastWeek: Date[] = this.dateHelperService.getLastWeek();

  sugeryDateProgress = 0;

  public currentWeek: Date[] = this.dateHelperService.getCurrentWeek();
  public today = this.dateHelperService.getToday();
  readMoveWell: any;

  allTargets:any;

  constructor(
    private userStepService: UserStepService,
    private userTargetService: UserTargetService,
    private userService: UserService,
    private router: Router,
    private dateHelperService: DateHelperService,
    private userBreathWorkoutService: UserBreathWorkoutService,
    private userCardioService: UserCardioService,
    private userStrengthWorkoutService: UserStrengthWorkoutService,
    private userEatWellService: UserEatWellService,
    private userSmokingService: UserSmokingService,
    private userDrinkService: UserDrinksService,
    private userFeelService: UserFeelsService,
    private userSleepService: UserSleepsService,
    private activityTrackerService: ActivityTrackerService,
    private userTaskStatusService: UserTaskStatusService,
  ) {}

  ngOnInit(): void {
    // work out what they have done.
    // get all the data..

    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
        this.currentWeekNumber =
          moment().diff(moment(userData.date_registered).startOf('week'), 'week') + 1;
          this.weekNo = this.currentWeekNumber;
          this.getWeekData();
      }
    });

 
  }


  getWeekData() {
    this.isLoading = true;
    //
    forkJoin({
      allSteps: this.userStepService.fetchAll(),
      allBreathWorkouts: this.userBreathWorkoutService.fetchAll(),
      allCardioWorkouts: this.userCardioService.fetchAll(),
      allCardioLevels: this.userCardioService.fetchLevelHistory(),
      allMoveWorkouts: this.userStrengthWorkoutService.fetchAll(),
      allMoveLevels: this.userStrengthWorkoutService.fetchLevelHistory(),
      allEatWells: this.userEatWellService.fetchAll(),
      allSmokings: this.userSmokingService.fetchAll(),
      allDrinks: this.userDrinkService.fetchAll(),
      allFeels: this.userFeelService.fetchAll(),
      allSleeps: this.userSleepService.fetchAll(),
      allUserTaskStatuses: this.userTaskStatusService.fetchAll(),
      allTargets: this.userTargetService.fetchAll()
    }).subscribe(
      (responseData) => {
        this.allTargets = responseData.allTargets;
        
        this.allTaskStatuses = responseData.allUserTaskStatuses;
        this.allSteps = responseData.allSteps;
        if (this.allSteps.length > 0) {
          this.pages.push('prepSteps');
        }

        this.allCardioWorkouts = responseData.allCardioWorkouts;
        if (this.allCardioWorkouts.length > 0) {
          this.pages.push('prepFit');
        }

        this.allMoveWorkouts = responseData.allMoveWorkouts;
        if (this.allMoveWorkouts.length > 0) {
          this.pages.push('prepStrong');
        }

        this.allBreathWorkouts = responseData.allBreathWorkouts;
        if (this.allBreathWorkouts.length > 0) {
          this.pages.push('breatheWell');
        }

        this.allEatWells = responseData.allEatWells;
        if (this.allEatWells.length > 0) {
          this.pages.push('eatWell');
        }

        this.allDrinks = responseData.allDrinks;
        if (this.allDrinks.length > 0) {
          this.pages.push('drinkingGuide');
        }
        this.allSmokings = responseData.allSmokings;
        if (this.allSmokings.length > 0) {
          this.pages.push('iQuit');
        }

        this.allSleeps = responseData.allSleeps;
        if (this.allSleeps.length > 0) {
          this.pages.push('sleepWell');
        }

        this.allFeels = responseData.allFeels;
        if (this.allFeels.length > 0) {
          this.pages.push('feelWell');
        }
        this.pageId = this.pages[0];

        // get all weeks data?
        let endOfWeek = this.currentWeek[6];
        let weeksRun = 0;

          this.userService.userData
            .pipe(first((userData) => userData !== null))
            .subscribe((userData) => {
              if (userData != null) {
                while (
                  moment(endOfWeek).subtract(1, 'week') >
                    moment(this.userData.date_registered) &&
                  weeksRun < 100
                ) {
                  weeksRun++;
                  let prevWeek = this.dateHelperService.getWeekFor(
                    moment(endOfWeek).subtract(1, 'week')
                  );

                  let prevWeekStepData = this.userStepService.generateWeekArray(
                    prevWeek,
                    this.allSteps
                  );

                  this.allWeeksStepData.push(prevWeekStepData);

                  let prevWeekCardioData =
                    this.userCardioService.generateWeekArray(
                      prevWeek,
                      this.allCardioWorkouts
                    );
                  this.allWeeksCardioData.push(prevWeekCardioData);

                  let prevWeekMoveData =
                    this.userStrengthWorkoutService.generateWeekArray(
                      prevWeek,
                      this.allMoveWorkouts
                    );
                  this.allWeeksMoveData.push(prevWeekMoveData);

                  let prevWeeksBreatheData =
                    this.userBreathWorkoutService.generateWeekArray(
                      prevWeek,
                      this.allBreathWorkouts
                    );
                  this.allWeeksBreatheData.push(prevWeeksBreatheData);

                  let prevWeeksEatwellData =
                    this.userEatWellService.generateWeekArray(
                      prevWeek,
                      this.allEatWells
                    );
                  this.allWeeksEatWellData.push(prevWeeksEatwellData);

                  let prevWeeksFeelwellData =
                    this.userFeelService.generateWeekArray(
                      prevWeek,
                      this.allFeels
                    );
                  this.allWeeksFeelWellData.push(prevWeeksFeelwellData);

                  let prevWeeksSleepwellData =
                    this.userSleepService.generateWeekArray(
                      prevWeek,
                      this.allSleeps
                    );
                  this.allWeeksSleepWellData.push(prevWeeksSleepwellData);

                  let prevWeeksSmokingData =
                    this.userSmokingService.generateWeekArray(
                      prevWeek,
                      this.allSmokings
                    );
                  this.allWeeksSmokingData.push(prevWeeksSmokingData);

                  let prevWeeksDrinkingData =
                    this.userDrinkService.generateWeekArray(
                      prevWeek,
                      this.allDrinks
                    );
                  this.allWeeksDrinkData.push(prevWeeksDrinkingData);

                  endOfWeek = prevWeek[6];
                }
                // report weeks?
                this.stepWeekData =
                  this.allWeeksStepData[
                    this.allWeeksStepData.length - this.weekNo
                  ];

                if (
                  this.allWeeksStepData[
                    this.allWeeksStepData.length - this.weekNo + 1
                  ]
                ) {
                  this.stepPrevWeekData =
                    this.allWeeksStepData[
                      this.allWeeksStepData.length - this.weekNo + 1
                    ];
                  this.stepDaysHitLastWeek = this.userStepService.getDaysHit(
                    this.stepPrevWeekData
                  );
                }
                this.weekStepTotal = this.userStepService.getTotalSteps(
                  this.stepWeekData
                );
                this.stepDaysHit = this.userStepService.getDaysHit(
                  this.stepWeekData
                );

                this.stepDaysHitFirstWeek = this.userStepService.getDaysHit(
                  this.allWeeksStepData[this.allWeeksStepData.length - 1]
                );

                this.cardioWeekData =
                  this.allWeeksCardioData[
                    this.allWeeksCardioData.length - this.weekNo
                  ];

                if (
                  this.allWeeksCardioData[
                    this.allWeeksCardioData.length - this.weekNo + 1
                  ]
                ) {
                  this.cardioPrevWeekData =
                    this.allWeeksCardioData[
                      this.allWeeksCardioData.length - this.weekNo + 1
                    ];
                }
                // what level were they start of this week?
                let startLevel = 1;
                responseData.allCardioLevels.forEach((moveWellLevel: any) => {
                  if (
                    moment(moveWellLevel.created) >=
                      moment(this.cardioWeekData[0].date) &&
                    moment(moveWellLevel.created) <=
                      moment(this.cardioWeekData[6].date)
                  ) {
                    this.cardioWeekProgressed = moveWellLevel.level;
                  }

                  if (
                    moment(moveWellLevel.created) <
                    moment(this.cardioWeekData[0].date)
                  ) {
                    startLevel = moveWellLevel.level;
                  }
                });

                // only log correct intensity minutes?
                /*
              1:'At least 150 minutes in total of moderate intensity aerobic training over a 7 day period.',
              
              2:'At least 75 minutes of vigorous intensity aerobic training logged over 7 days.',
             
              3:'Three sessions of 45-50 minutes vigorous aerobic training per week.',
              */

                this.cardioWeekData.forEach((day: any) => {
                  this.cardioMinsWeek += +day.minutes;
                  this.cardioMinsWeekModerate += day.moderateMinutes;
                  this.cardioMinsWeekVigorous += day.vigorousMinutes;
                });

                if (startLevel == 1) {
                  if (
                    this.cardioMinsWeekModerate + this.cardioMinsWeekVigorous >=
                    150
                  ) {
                    this.cardioWeekHit = true;
                  }
                }
                if (startLevel == 2) {
                  if (this.cardioMinsWeekVigorous >= 75) {
                    this.cardioWeekHit = true;
                  }
                }
                if (startLevel == 3) {
                  // TO DO LEVEL 3
                }
                if (this.cardioPrevWeekData) {
                  this.cardioPrevWeekData.forEach((day: any) => {
                    this.cardioMinsLastWeek += +day.minutes;
                    this.cardioMinsLastWeekModerate += day.moderateMinutes;
                    this.cardioMinsLastWeekVigorous += day.vigorousMinutes;
                  });
                }

                this.allWeeksCardioData[
                  this.allWeeksCardioData.length - 1
                ].forEach((day: any) => {
                  this.cardioMinsFirstWeek += +day.minutes;
                });

                this.moveWeekData =
                  this.allWeeksMoveData[
                    this.allWeeksMoveData.length - this.weekNo
                  ];
                responseData.allMoveLevels.forEach((moveWellLevel: any) => {
                  if (
                    moment(moveWellLevel.created) >=
                      moment(this.moveWeekData[0].date) &&
                    moment(moveWellLevel.created) <=
                      moment(this.moveWeekData[6].date)
                  ) {
                    this.moveWeekProgressed = moveWellLevel.level;
                  }
                });

                this.moveWeekData.forEach((workout: any) => {
                  if (workout.total_reps > 0) {
                    this.moveWeekWorkouts++;
                  }
                });

                if (this.moveWeekWorkouts >= 2) {
                  this.moveWeekHit = true;
                }

                if( this.allWeeksMoveData[
                  this.allWeeksMoveData.length - this.weekNo + 1
                ]){
                this.allWeeksMoveData[
                  this.allWeeksMoveData.length - this.weekNo + 1
                ].forEach((workout: any) => {
                  if (workout.total_reps > 0) {
                    this.moveLastWeekWorkouts++;
                  }
                });

              }
                this.allWeeksMoveData[this.allWeeksMoveData.length - 1].forEach(
                  (workout: any) => {
                    if (workout.total_reps > 0) {
                      this.moveFirstWeekWorkouts++;
                    }
                  }
                );

                this.breatheWeekData =
                  this.allWeeksBreatheData[
                    this.allWeeksBreatheData.length - this.weekNo
                  ];

                // level change?
                this.thisWeekBreatheMax = 0;
                this.breatheWeekData.forEach((day: any) => {
                  if (day.am.resistance > this.thisWeekBreatheMax) {
                    this.thisWeekBreatheMax = day.am.resistance;
                  }
                  if (day.pm.resistance > this.thisWeekBreatheMax) {
                    this.thisWeekBreatheMax = day.pm.resistance;
                  }

                  if (day.am.breaths > 0) {
                    this.breatheSessions++;
                  }
                  if (day.pm.breaths > 0) {
                    this.breatheSessions++;
                  }
                });

                this.lastWeekBreatheMax = 0;
                if (
                  this.allWeeksBreatheData[
                    this.allWeeksBreatheData.length - this.weekNo + 1
                  ]
                ) {
                  this.allWeeksBreatheData[
                    this.allWeeksBreatheData.length - this.weekNo + 1
                  ].forEach((day: any) => {
                    if (day.am.resistance > this.lastWeekBreatheMax) {
                      this.lastWeekBreatheMax = day.am.resistance;
                    }
                    if (day.pm.resistance > this.lastWeekBreatheMax) {
                      this.lastWeekBreatheMax = day.pm.resistance;
                    }

                    if (day.am.breaths > 0) {
                      this.breatheSessionsLastWeek++;
                    }
                    if (day.pm.breaths > 0) {
                      this.breatheSessionsLastWeek++;
                    }
                  });
                }

                this.allWeeksBreatheData[
                  this.allWeeksBreatheData.length - 1
                ].forEach((day: any) => {
                  if (day.am.resistance > this.firstWeekBreatheMax) {
                    this.firstWeekBreatheMax = day.am.resistance;
                  }
                  if (day.pm.resistance > this.firstWeekBreatheMax) {
                    this.firstWeekBreatheMax = day.pm.resistance;
                  }

                  if (day.am.breaths > 0) {
                    this.breatheSessionsFirstWeek++;
                  }
                  if (day.pm.breaths > 0) {
                    this.breatheSessionsFirstWeek++;
                  }
                });

                if (
                  this.thisWeekBreatheMax > 0 &&
                  this.lastWeekBreatheMax > 0
                ) {
                  this.breathLevelChange =
                    this.thisWeekBreatheMax - this.lastWeekBreatheMax;
                }

                this.eatWellWeekData =
                  this.allWeeksEatWellData[
                    this.allWeeksEatWellData.length - this.weekNo
                  ];

                this.eatWellTotals = this.userEatWellService.geterateWeekTotals(
                  this.eatWellWeekData
                );

                this.eatWellStats = this.userEatWellService.getStats(
                  this.eatWellWeekData
                );
                this.eatWellWeekData.forEach((day: any) => {
                  if (day.hasData) {
                    if (
                      +day.protein >= 3 &&
                      +day.carbs >= 3 &&
                      +day.fat >= 3 &&
                      +day.fruit_veg >= 5 &&
                      +day.hydration <= 3
                    ) {
                      this.eatWellDaysHit++;
                    }
                  }
                });

                if (
                  this.allWeeksEatWellData[
                    this.allWeeksEatWellData.length - this.weekNo + 1
                  ]
                ) {
                  this.allWeeksEatWellData[
                    this.allWeeksEatWellData.length - this.weekNo + 1
                  ].forEach((day: any) => {
                    if (day.hasData) {
                      if (
                        +day.protein >= 3 &&
                        +day.carbs >= 3 &&
                        +day.fat >= 3 &&
                        +day.fruit_veg >= 5 &&
                        +day.hydration <= 3
                      ) {
                        this.eatWellDaysHitLastWeek++;
                      }
                    }
                  });
                  this.eatWellStatsLastWeek = this.userEatWellService.getStats(
                    this.allWeeksEatWellData[
                      this.allWeeksEatWellData.length - this.weekNo + 1
                    ]
                  );
                  this.eatWellTotalsLastWeek =
                    this.userEatWellService.geterateWeekTotals(
                      this.allWeeksEatWellData[
                        this.allWeeksEatWellData.length - this.weekNo + 1
                      ]
                    );
                }

                this.allWeeksEatWellData[
                  this.allWeeksEatWellData.length - 1
                ].forEach((day: any) => {
                  if (day.hasData) {
                    if (
                      +day.protein >= 3 &&
                      +day.carbs >= 3 &&
                      +day.fat >= 3 &&
                      +day.fruit_veg >= 5 &&
                      +day.hydration <= 3
                    ) {
                      this.eatWellDaysHitFirstWeek++;
                    }
                  }
                });

                this.eatWellStatsFirstWeek = this.userEatWellService.getStats(
                  this.allWeeksEatWellData[this.allWeeksEatWellData.length - 1]
                );

                this.eatWellTotalsFirstWeek =
                  this.userEatWellService.geterateWeekTotals(
                    this.allWeeksEatWellData[
                      this.allWeeksEatWellData.length - 1
                    ]
                  );

                this.smokingWeekData =
                  this.allWeeksSmokingData[
                    this.allWeeksSmokingData.length - this.weekNo
                  ];

                this.smokingTotals = this.userSmokingService.geterateWeekTotals(
                  this.smokingWeekData
                );
                if (
                  this.allWeeksSmokingData[
                    this.allWeeksSmokingData.length - this.weekNo + 1
                  ]
                ) {
                  this.smokingTotalsLastWeek =
                    this.userSmokingService.geterateWeekTotals(
                      this.allWeeksSmokingData[
                        this.allWeeksSmokingData.length - this.weekNo + 1
                      ]
                    );
                }
                this.smokingTotalsFirstWeek =
                  this.userSmokingService.geterateWeekTotals(
                    this.allWeeksSmokingData[
                      this.allWeeksSmokingData.length - 1
                    ]
                  );

                this.drinkWeekData =
                  this.allWeeksDrinkData[
                    this.allWeeksDrinkData.length - this.weekNo
                  ];

                this.drinkTotals = this.userDrinkService.geterateWeekTotals(
                  this.drinkWeekData
                );
                if (
                  this.allWeeksDrinkData[
                    this.allWeeksDrinkData.length - this.weekNo + 1
                  ]
                ) {
                  this.drinkTotalsLastWeek =
                    this.userDrinkService.geterateWeekTotals(
                      this.allWeeksDrinkData[
                        this.allWeeksDrinkData.length - this.weekNo + 1
                      ]
                    );
                }
                this.drinkTotalsFirstWeek =
                  this.userDrinkService.geterateWeekTotals(
                    this.allWeeksDrinkData[this.allWeeksDrinkData.length - 1]
                  );

                this.sleepWeekData =
                  this.allWeeksSleepWellData[
                    this.allWeeksSleepWellData.length - this.weekNo
                  ];

                this.sleepTotal = this.userSleepService.getWeekScore(
                  this.sleepWeekData
                );

                if (
                  this.allWeeksSleepWellData[
                    this.allWeeksSleepWellData.length - this.weekNo + 1
                  ]
                ) {
                  this.sleepTotalLastWeek = this.userSleepService.getWeekScore(
                    this.allWeeksSleepWellData[
                      this.allWeeksSleepWellData.length - this.weekNo + 1
                    ]
                  );
                }
                this.sleepTotalFirstWeek = this.userSleepService.getWeekScore(
                  this.allWeeksSleepWellData[
                    this.allWeeksSleepWellData.length - 1
                  ]
                );

                this.feelWeekData =
                  this.allWeeksFeelWellData[
                    this.allWeeksFeelWellData.length - this.weekNo
                  ];

                this.feelTotal = this.userFeelService.getWeekScore(
                  this.feelWeekData
                );

                if (
                  this.allWeeksFeelWellData[
                    this.allWeeksFeelWellData.length - this.weekNo + 1
                  ]
                ) {
                  this.feelTotalLastWeek = this.userFeelService.getWeekScore(
                    this.allWeeksFeelWellData[
                      this.allWeeksFeelWellData.length - this.weekNo + 1
                    ]
                  );
                }
                this.feelTotalFirstWeek = this.userFeelService.getWeekScore(
                  this.allWeeksFeelWellData[
                    this.allWeeksFeelWellData.length - 1
                  ]
                );
              }
            });
        

        this.isLoading = false;
      },
      (error) => {}
    );
  }
}
